import { useState } from "preact/compat";
import { AddIcon, RemoveIcon } from "../Icons";
import classNames from 'classnames';
import useId from "../utilities/useId";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/compat/jsx-runtime";
export const AccordionItem = _ref => {
  let {
    buttonClassName,
    children,
    contentClassName,
    defaultOpen = false,
    heading,
    headingClassName,
    headingLevel = '2',
    id,
    // TODO: Explore deprecating `isControlledOpen` in favor of `isOpen`
    isControlledOpen,
    onChange,
    closeIconComponent = RemoveIcon,
    openIconComponent = AddIcon
  } = _ref;
  const contentClasses = classNames('ds-c-accordion__content', contentClassName);
  const buttonClasses = classNames('ds-c-accordion__button', buttonClassName);
  const headingClasses = classNames('ds-c-accordion__heading', headingClassName);
  const HeadingTag = `h${headingLevel}`;
  const contentId = useId('accordion-item--', id);
  const buttonId = `${contentId}__button`;
  const isControlled = isControlledOpen !== undefined;
  const [isOpen, setIsOpen] = useState(isControlled ? isControlledOpen : defaultOpen);
  const handleClick = event => {
    onChange?.(event);
    if (!isControlled) {
      setIsOpen(!isOpen);
    }
  };
  const isItemOpen = isControlled ? isControlledOpen : isOpen;
  const CloseIconComponent = closeIconComponent;
  const OpenIconComponent = openIconComponent;
  const closeIcon = /*#__PURE__*/_jsx(CloseIconComponent, {
    className: "ds-c-accordion__button-icon",
    id: `${contentId}__icon`
  });
  const openIcon = /*#__PURE__*/_jsx(OpenIconComponent, {
    className: "ds-c-accordion__button-icon",
    id: `${contentId}__icon`
  });
  if (heading) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(HeadingTag, {
        className: headingClasses,
        children: /*#__PURE__*/_jsxs("button", {
          className: buttonClasses,
          "aria-expanded": isItemOpen,
          "aria-controls": contentId,
          id: buttonId,
          onClick: handleClick,
          type: "button",
          children: [heading, isItemOpen ? closeIcon : openIcon]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: contentClasses,
        id: contentId,
        hidden: isControlled ? !isControlledOpen : !isOpen,
        children: children
      })]
    });
  }
};
export default AccordionItem;